import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Image from 'react-bootstrap/Image';
import Dropdown from 'react-bootstrap/Dropdown';
import React, {useEffect, useRef, useState} from "react";
import {DateBox, Popover, SelectBox, Template} from "devextreme-react";
import {alert} from 'devextreme/ui/dialog'
import LoaderService from "../../../RetroAssets.System/LoaderService";
import apiClient from "../../../services/axios";
import cl from "../../../RetroAssets.System/Utilities";
import {DataGrid} from "devextreme-react/data-grid";
import {ContextMenuTemplate, MoreOptionsButton} from "../../../RetroAssets.System/MoreOptionsButton";
import Button from "react-bootstrap/Button";
import ROIProjectionsFormulas from "../../Popups/ROIProjectionsFormulas";


const ROIProjections = (props) => {
    const {accounts, propListing, loaded} = props
    const [date, setDate] = useState({
        d1: new Date(new Date().setFullYear(new Date().getFullYear() - 4)),
        d2: new Date(),
    })
    const [accountCounts, setAccountCounts] = useState([]);
    const [filteredProperties, setFilteredProperties] = useState([])
    const [propSelection, setPropSelection] = useState([])
    // Which calendar year the Cap Rate column reports. The server resolves it from the
    // date window and returns it, so the rule lives in exactly one place. null means the
    // window holds no complete calendar year and every Cap Rate cell reads N/A.
    const [capRateYear, setCapRateYear] = useState(null)
    const popoverRef = useRef(null)
    const gridInstance = useRef(null)
    let spanString = "Dashboard_ROIProjections"
    const [viewFormulaDetails, setViewFormulaDetails] = useState(false)

    const [settings, setSettings] = useState({
        data: [],
        columns: [],
        gridCustomization: {},
    })

    useEffect(() => {
        if (accounts.length === 0 || propListing.length === 0 || !loaded) return
        setAccountCounts(accounts)
        setFilteredProperties(propListing[0]['Data'])
        loadData()
    }, [accounts, propListing, loaded]);

    const loadData = () => {
        LoaderService.setData(true)
        let params = new URLSearchParams({
            externalIds: propSelection.toString(),
            date1: date.d1.toJSON(),
            date2: date.d2.toJSON(),
        })
        apiClient
            .get('/Dashboard/GetROIProjectionPivotReport?' + params)
            .then(response => {
                try {
                    let data = JSON.parse(response.data)
                    let settings = data[1]["Settings"]
                    setSettings({
                        ...settings,
                        data: data[0]["Data"],
                        columns: settings[0][spanString][0]["Columns"],
                        gridCustomization: settings[0][spanString][3]["GridCustomization"][0],
                    })
                    setCapRateYear(data.length > 2 && data[2]["CapRate"] ? data[2]["CapRate"]["Year"] : null)
                    LoaderService.setData(false)
                } catch (e) {
                    LoaderService.setData(false)
                    return alert(response.data, 'Error!')
                }
            })
            .catch(err => {
                LoaderService.setData(false)
                console.log(err)
                return alert(err, 'Error!')
            })
    }

    const dateBoxValueChanged = e => {
        let property = e.component.option("property");
        if (e.component.NAME === "dxDateBox") {
            const text = (e.component.option('text') || '').toString()
            e.value = cl.normalizeAndValidateDate(text)
        }
        setDate({
            ...date,
            [property]: e.value
        })
    }

    const propertyChanged = (e) => {
        if (e.currentTarget.checked) {
            propSelection.push(e.currentTarget.id)
        } else {
            let index = propSelection.indexOf(e.currentTarget.id)
            propSelection.splice(index, 1)
        }
        setPropSelection(propSelection)
    }

    const RenderPopoverTemplate = () => {
        const changeColor = (colorCode) => {
            LoaderService.setData(true)
            let selectedRowId = gridInstance.current.instance().getSelectedRowKeys()[0];

            let params = new URLSearchParams({
                objectName: "Property",
                externalId: selectedRowId,
                color: colorCode,
                remove: colorCode === null
            })
            apiClient
                .get('/Shared/UpdateObjectColor?' + params)
                .then(response => {
                    try {
                        LoaderService.setData(false)
                        let resp = JSON.parse(response.data)
                        if (resp[0].response) {
                            let dt = settings.data
                            let index = dt.findIndex(x => x.externalId === selectedRowId)
                            if (index > -1) {
                                dt[index]["Color"] = colorCode
                                setSettings({
                                    ...settings,
                                    data: dt
                                })
                                gridInstance.current.instance().refresh()
                            }
                        } else {
                            return alert(resp[0].message, 'Warning!')
                        }
                        LoaderService.setData(false)
                    } catch (e) {
                        LoaderService.setData(false)
                        return alert(response.data, 'Error!')
                    }

                })
                .catch(err => {
                    LoaderService.setData(false)
                    console.log(err)
                    return alert(err, 'Error!')
                })
        }
        return (
            <>
                <span className="dot dot-color1" onClick={() => changeColor("#D2E2FF")}></span>
                <span className="dot dot-color2" onClick={() => changeColor("#FEE8B3")}></span>
                <span className="dot dot-color3" onClick={() => changeColor("#B1E3CE")}></span>
                <span className="dot dot-color4" onClick={() => changeColor("#D4D4D4")}></span>
                <span className="dot dot-color5" onClick={() => changeColor("#FFCFAF")}></span>
                <span className="dot dot-color6" onClick={() => changeColor("#EDD7FF")}></span>
                <span className="dot dot-color7" onClick={() => changeColor("#FFA7A7")}></span>
                <span className="dot dot-none" onClick={() => changeColor(null)}> </span>
            </>
        )
    }

    const cellPrepared = e => {
        cl.setObjectColor(e)
        cl.setHeaderTooltip(e)
    }

    const rowClickEvent = e => {
        popoverRef.current.instance().option("target", e.rowElement)
        popoverRef.current.instance().show();
    }

    return (
        <div className="main-wrapper p-3">
            <Card className="p-3 border-0 status-card h-100 dashboard-border">
                <div className="d-flex align-items-center justify-content-md-end flex-wrap flex-md-nowrap">
                    <div className="date-filter d-flex align-items-center me-sm-3 mb-3 mb-md-0">
                        <div
                            className="datepicker-input d-flex flex-wrap flex-sm-nowrap align-items-center px-sm-2">
                            <Image src="/svg/calendar.svg" alt="calendar" width="15" height="15"/>
                            <span className="flex-shrink-0 ms-1 me-2 text-secondary mb-1 mb-sm-0">From date</span>
                            <DateBox width={120} value={date.d1} className="input-xs"
                                     elementAttr={{class: 'date-box-group'}}
                                     displayFormat="dd/MM/yyyy"
                                     stylingMode="filled"
                                     style={{background: "#fff", borderRadius: "2px", border: '1px solid #eee'}}
                                     property="d1"
                                     onValueChanged={dateBoxValueChanged}
                            ></DateBox>
                        </div>
                        <div
                            className="datepicker-input d-flex flex-wrap flex-sm-nowrap align-items-center px-sm-2 ms-2">
                            <Image src="/svg/calendar.svg" alt="calendar" width="15" height="15"/>
                            <span className="flex-shrink-0 ms-1 me-2 text-secondary mb-1 mb-sm-0">To date</span>
                            <DateBox width={120} value={date.d2} className="input-xs"
                                     elementAttr={{class: 'date-box-group'}}
                                     displayFormat="dd/MM/yyyy"
                                     stylingMode="filled"
                                     style={{background: "#fff", borderRadius: "2px", border: '1px solid #eee'}}
                                     property="d2"
                                     onValueChanged={dateBoxValueChanged}
                            ></DateBox>
                        </div>
                    </div>
                    <div className="dropdown-filter d-flex align-items-center mb-3 mb-md-0">
                        <div className="rent-overview-dropdown me-3">
                            <Dropdown className="select-prop">
                                <Dropdown.Toggle variant="default" id="prop-selct"
                                                 className="cc-border-dark d-flex text-secondary">
                                    <Image src="/svg/building.svg" alt="building" width="15" height="15"/>
                                    [{propSelection.length}] properties selected
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="shadow-sm border-0 p-3">
                                    {filteredProperties.map((prop) => {
                                        return (<div className="dropdown-items py-1">
                                            <Form.Check type="checkbox"
                                                        id={prop["externalId"]}
                                                        onClick={propertyChanged}
                                                        label={prop["Name"]}/>
                                        </div>)
                                    })}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <Button variant="outline-primary" className="flex-shrink-0 me-3"
                                onClick={loadData}>
                            Load
                        </Button>
                        <Button variant="outline-primary" className="flex-shrink-0 me-3"
                                onClick={() => {
                                    setViewFormulaDetails(true)
                                }}>
                            View Calculation Details
                        </Button>
                    </div>
                </div>
                {/*  The Cap Rate column is the one annual figure on this grid. Everything else
                     is accumulated since the property was bought, so the two scales are stated
                     here rather than left for the reader to guess from a column header. */}
                <div className="text-secondary small px-3 pt-2">
                    {capRateYear
                        ? `Cap Rate is net operating income for CY${capRateYear} divided by current market price, as a percentage. `
                        + `CY${capRateYear} is the latest complete calendar year in the selected date range. `
                        + `N/A means the property has no current market price recorded. `
                        + `Every other column is accumulated since inception and ignores the date range.`
                        : `Cap Rate reads N/A on every row: the selected date range contains no complete calendar year, `
                        + `and a cap rate is a yield per year. Every other column is accumulated since inception `
                        + `and ignores the date range.`}
                </div>
                {/*  The column headed "Cash on Cash Return" does not compute cash-on-cash: its
                     numerator is cumulative net income, not before-tax cash flow, and its
                     denominator is purchase cost, not equity (ROIProjections.txt:187-190). It is
                     a cumulative net income return on cost. The header itself is a VM_Column.Caption
                     row and cannot be corrected from this repository, so the correction is stated
                     here. The capital gain leg is deliberately not in it - that is the separate
                     Capital Gains and Appreciation Rate columns - so it is not a total return. */}
                <div className="text-secondary small px-3 pb-2">
                    {`Cash on Cash Return is cumulative net income divided by purchase cost, shown as a ratio, not a percentage. `
                    + `It is a return on cost, not on equity, and it excludes the capital gain leg - see Capital Gains and `
                    + `Appreciation Rate for that - so it is not a total return.`}
                </div>
                <div className="rent-overview-tabs p-3">
                    <Popover
                        ref={popoverRef}
                        showEvent="dxclick"
                        hideOnOutsideClick={true}
                        width={180}
                        contentRender={RenderPopoverTemplate}
                    >
                    </Popover>
                    <DataGrid
                        ref={gridInstance}
                        dataSource={settings.data}
                        {...settings.gridCustomization}
                        keyExpr="externalId"
                        height={600}
                        onRowClick={rowClickEvent}
                        onCellPrepared={cellPrepared}
                    >
                        {settings.columns.map((column, i) => (
                            cl.generateReactColumnsFromJson(column)
                        ))}
                        {settings.columns.map((column, i) => (
                            cl.generateActionButtonColumn(column)
                        ))}
                        <Template name="myTemplate" render={MoreOptionsButton}/>
                        <Template name="contextMenuTemplate" render={ContextMenuTemplate}/>
                    </DataGrid>
                </div>
            </Card>
            <ROIProjectionsFormulas
                show={viewFormulaDetails}
                handleClose={() => setViewFormulaDetails(false)}
            ></ROIProjectionsFormulas>
        </div>
    );
}

export default ROIProjections;

